import msg0 from './msg0.png'
import msg1 from './msg1.png'
import msg from './msg.png'
import msg11 from './msg(1).png'
import msgMin0 from './msg-min0.png'
import msgMin1 from './msg-min1.png'
import msgMin2 from './msg-min2.png'
import msgMin3 from './msg-min3.png'
import banner2 from './banner2.png'
import banner3 from './banner3.png'
import banner4 from './banner4.png'
import banner5 from './banner5.png'
import banner6 from './banner6.png'
import banner7 from './banner7.png'
import banner8 from './banner8.png'
import logo1 from './logo1.png'
import logo2 from './logo2.png'
import logo3 from './logo3.png'
import msg2 from './msg2.png'
import msg3 from './msg3.png'
import msg4 from './msg4.png'
import msg5 from './msg5.png'
import msg6 from './msg6.png'
import box from './box.png'
import btn from './btn.png'
let msgMin = [
  msgMin0,
  msgMin1,
  msgMin2,
  msgMin3
]
export {
  msg0 as msg0,
  msg1 as msg1,
  msg as msg,
  msg11 as msg11,
  msgMin as msgMin,
  banner2 as banner2,
  banner3 as banner3,
  banner4 as banner4,
  banner5 as banner5,
  banner6 as banner6,
  banner7 as banner7,
  banner8 as banner8,
  logo1 as logo1,
  msg2 as msg2,
  logo2 as logo2,
  logo3 as logo3,
  msg3 as msg3,
  msg4 as msg4,
  msg5 as msg5,
  msg6 as msg6,
  box as box,
  btn as btn
}


// WEBPACK FOOTER //
// ./src/images/box/index.js